<template>
  <div>
    <!-- todo - https://stackoverflow.com/questions/50392918/vuetify-how-to-preselect-active-tab
     -->
    <v-tabs v-model="activetab" align-with-title>
      <v-tab  v-for="tab of tabs"  :key="tab.id" @click="WarnUser(tab.to)">
        <span>{{ tab.caption }}</span>
      </v-tab>
    </v-tabs>
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'MiscellaneousReceipts',
  components: {
  },
  data: () => ({
    dialog: false,
    path: '',
    activetab: 0,
    tabs: [
      { id: 1, to: { path: '/misc/transactions' }, caption: 'Miscellaneous Receipts' },
      { id: 2, to: { path: '/misc/browse/unitschoolcode' }, caption: 'Browse' },
      { id: 3, to: { path: '/misc/reports' }, caption: 'Reports' },
      { id: 4, to: { path: '/misc/utils/createfiscalyear' }, caption: 'Utils' },
    ],
  }),
  methods: {
    WarnUser(path) {
      this.path = path;
      const currentpath = this.$router.currentRoute.path;
      if (path.path !== currentpath) {
        this.$router.push(path);
      }
    },
  },
  computed: {
  },
};
</script>
